import { AxiosError } from 'axios';
import request from 'common/request';
import { useQuery } from 'react-query';

export const useGetUserInfo = ( options?: any) => {
  return useQuery<any, AxiosError>(
    'userInfoData',
    async () => {
      try {
        const response = await request.get(`/mypage/info`,
        );
        
        return response.data;
      } catch (e) {
        //@ts-ignore
        const result = e.response
        return result
      }
    },
    {
      ...options,
    }
  );
};

export default useGetUserInfo;
